import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as shipmentActions, fetchShipmentsWithFilters } from './store/slice';
import {
  selectShipmentFilterVisible,
  selectShipmentFilters,
  selectShipmentData,
  selectShipmentPagination,
} from './store/selectors';
import { all_routes } from '../../router/all_routes';

const {
  setFilterVisible,
  setPageSearchText,
  setCustomer,
  setStatus,
  setShipDate,
} = shipmentActions;

const ShipmentSearch = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const filterVisible = useSelector(selectShipmentFilterVisible);
  const { pageSearchText } = useSelector(selectShipmentFilters);
  const loadedCount = useSelector(state => (selectShipmentData(state) || []).length);
  const { totalCount } = useSelector(selectShipmentPagination);
  const searchTimerRef = useRef(null);
  const isCustomerDashboard = location.pathname === all_routes.shipments;

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  const handleSearch = e => {
    const value = e.target.value;
    dispatch(setPageSearchText(value));
    if (searchTimerRef.current)  {
      clearTimeout(searchTimerRef.current);
    }
    searchTimerRef.current = setTimeout(() => {
      dispatch(fetchShipmentsWithFilters());
    }, 400);
  };

  const toggleFilterVisibility = e => {
    e.preventDefault();
    e.stopPropagation();
    const opening = !filterVisible;
    dispatch(setFilterVisible(opening));

    // Closing filter section → clear Customer + Status (+ date / search) and reset list
    if (!opening) {
      if (!isCustomerDashboard) {
        dispatch(setCustomer(null));
      }
      dispatch(setStatus(null));
      dispatch(setShipDate(null));
      dispatch(setPageSearchText(''));
      dispatch(
        fetchShipmentsWithFilters({
          ...(isCustomerDashboard ? {} : { customer: null }),
          status: null,
          shipDate: null,
          pageSearchText: '',
        }),
      );
    }
  };

  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  const formatCount = value => Number(value || 0).toLocaleString();

  return (
    <>
      <div className="search-set">
        <div className="search-input" style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search ASP, trailer, PSN, or customer"
                aria-controls="DataTables_Table_0"
                value={pageSearchText || ''}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
      <div className="search-path" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span
          style={{
            fontSize: 13,
            color: '#475467',
            whiteSpace: 'nowrap',
            fontWeight: 500,
          }}
          title="Loaded records of total matching records"
        >
          {formatCount(loadedCount)} of {formatCount(totalCount)} records
        </span>
        <button
          type="button"
          className={`btn btn-filter ${filterVisible ? 'setclose' : ''}`}
          id="shipment_filter_search"
          onClick={toggleFilterVisibility}
          aria-label={filterVisible ? 'Close filters' : 'Open filters'}
        >
          <Filter className="filter-icon" />
          <span>
            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
          </span>
        </button>
      </div>
      <div className="form-sort" style={{ display: 'none' }}>
        <Sliders className="info-img" />
        <Select
          className="img-select"
          classNamePrefix="react-select"
          options={oldandlatestvalue}
          placeholder="Newest"
        />
      </div>
    </>
  );
};

export default ShipmentSearch;
